<template>
  <v-dialog
    v-model="internalDialog"
    :max-width="maxWidth"
    :persistent="persistent"
  >
    <v-card>
      <slot />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: String,
      default: '100%',
    },
    persistent: {
      Boolean,
      default: false,
    },
  },
  watch: {
    dialog(val) {
      this.internalDialog = val
    },
    internalDialog(val) {
      if (!val) {
        this.$emit('close')
      }
    },
  },
  data() {
    return {
      internalDialog: this.dialog,
    }
  },
  methods: {
    close() {
      this.internalDialog = false
    },
  },
}
</script>
